<template>
  <div data-v-5fea6048="" data-v-2ac6a5fc="" class="addMethod">
    <div data-v-5fea6048="" class="content">
      <div data-v-5fea6048="">
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankName">钱包协议</label>
          <div data-v-5fea6048="" class="form-input-group">
            <input data-v-5fea6048="" v-model="meyXi" readonly="" type="text" placeholder="请选择钱包协议" class="" />
            <select data-v-5fea6048="" id="bankName" v-model="meyXi" class="select-input">
              <option data-v-5fea6048="" value="ERC20">ERC20</option>
              <option data-v-5fea6048="" value="TRC20">TRC20</option>
            </select>
            <span data-v-5fea6048="" class="arrow"></span>
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankCardNo">钱包地址</label>
          <div data-v-5fea6048="" class="form-input-group error">
            <input data-v-5fea6048="" id="bankCardNo" maxlength="19" v-model="usdss" oninput="value=value.replace(/[\W]/g,'')" type="text" placeholder="请输入钱包地址" class="" />
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>

        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankBranchName">支付密码</label>
          <div data-v-5fea6048="" class="form-input-group">
            <input data-v-5fea6048="" id="bankBranchName" maxlength="80" type="password" autocomplete="new-password" v-model="pay_pass" placeholder="请输入支付密码" class="" />
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
      </div>
      <div data-v-5fea6048="" class="button-wrapper">
        <button data-v-5fea6048="" class="active" @click="bindUsdss">保存</button>
      </div>
      <p data-v-5fea6048="" class="add-error-tips">无法绑定？<span data-v-5fea6048="" @click="$parent.openKefu" class="c-yellow">联系客服</span></p>
    </div>

  </div>
</template>
<script>
export default {
  name: 'addBankCard',
  data() {
    return { baseURL: '', bank: null, bank_owner: null, pay_pass: null, bank_no: null, bank_address: null,usdss:null
    ,  
      meyXi: 'ERC20', //qian
    
    };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    // that.getBanklist();
  },
  methods: {
    getBanklist() {
      let that = this;
      that.$apiFun.post('/api/banklist', {}).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.banklist = res.data;
        }
      });
    },
        bindUsdss() {
      let that = this;
      let usdss = that.usdss;
      let meyXi = that.meyXi;

      if (usdss == null || usdss == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!meyXi) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', { bank: 'USDT', bank_no: usdss, bank_owner: meyXi, pay_pass: that.pay_pass })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1,'添加成功！');
                   that.$router.back();

          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.bank_owner) {
        that.$parent.showTost(0, '请输入姓名');
        return;
      }
      if (!that.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.bank_no) {
        that.$parent.showTost(0, '请输入银行卡号');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.bank_no.length < 8) {
        that.$parent.showTost(0, '请输入正确的卡号长度');
        return;
      }
      if (that.pay_pass.length < 6 || that.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输入支付密码长度');
        return;
      }
      that.$parent.showLoading();
      let info = { bank_owner: that.bank_owner, bank: that.bank, bank_address: that.bank_address, bank_no: that.bank_no, pay_pass: that.pay_pass };
      that.$apiFun
        .post('/api/bindcard', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            // that.$router.go(-1);
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-279436a8.b8591cd3.css';
</style>



// WEBPACK FOOTER //
// src/components/main/addUsdtCard.vue